var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"subComp flex flex-c",style:('background-color:' + ( _vm.bgColor || '#ffffff') + ';')},[_c('ul',{staticClass:"flex"},_vm._l((_vm.linkData),function(item,index){return _c('li',{key:index,staticClass:"item"},[_c('a',{staticClass:"link",attrs:{"href":item.link}},[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }